import { FAQ } from '../types';

export const faqs: FAQ[] = [
  {
    id: 1,
    question: "What services does ProdAI Consulting provide?",
    answer: "We provide end-to-end AI product development consulting, including strategy development, MVP design, user research, product-market fit assessment, and AI ethics guidance. Our focus is on helping businesses transform AI concepts into successful market-ready products.",
    category: "Services"
  },
  {
    id: 2,
    question: "How do you typically engage with clients?",
    answer: "We begin with a free strategy call to understand your needs and challenges. From there, we create a tailored engagement plan that may include workshops, ongoing advisory sessions, and hands-on guidance throughout your AI product development journey.",
    category: "Process"
  },
  {
    id: 3,
    question: "What industries do you work with?",
    answer: "We work across various industries including healthcare, finance, retail, and enterprise software. Our expertise lies in the product development process itself, allowing us to add value regardless of the specific industry context.",
    category: "Experience"
  },
  {
    id: 4,
    question: "How do you ensure AI products are built ethically?",
    answer: "Ethics is central to our approach. We help teams implement responsible AI practices, including bias testing, transparency measures, and governance frameworks. We believe ethical AI is not just about compliance—it's about building products that users trust and that create sustainable value.",
    category: "Ethics"
  },
  {
    id: 5,
    question: "What's your approach to AI product development?",
    answer: "Our approach combines lean methodology with AI-specific best practices. We focus on rapid validation of assumptions, iterative development, and close user feedback loops. This helps teams avoid common pitfalls and build products that truly meet user needs.",
    category: "Process"
  },
  {
    id: 6,
    question: "How long does a typical engagement last?",
    answer: "Engagement length varies based on project scope and needs. Some clients engage us for focused 2-3 month MVP development periods, while others prefer ongoing advisory relationships. We're flexible and can adapt to your specific situation.",
    category: "Process"
  },
  {
    id: 7,
    question: "Do you help with technical implementation?",
    answer: "While we don't do direct coding or implementation, we provide technical guidance and help teams make informed decisions about AI technologies, architectures, and tools. We can also help you evaluate and select technical partners when needed.",
    category: "Services"
  },
  {
    id: 8,
    question: "How do you measure success in AI product development?",
    answer: "We define success metrics upfront with each client, typically including both technical metrics (model performance, reliability) and business metrics (user adoption, revenue, cost savings). Our focus is always on delivering measurable business value.",
    category: "Process"
  }
];